module.exports = __webpack_public_path__ + "static/zxjs-3ecee47236f47078a97249c39fe31f6b.mp4";